import { gql } from '@apollo/client';

export const PLAN_OWNERS = gql`
  query PlanOwners {
    planOwners {
      id
      name
      ceo
      logo
    }
  }
`;

export const PLAN_OWNER = gql`
  query PlanOwner($id: ID!) {
    planOwner(id: $id) {
      id
      name
      ceo
      phone
      email
      webSite
      about
      logo
      photos
      recommendedBy
      specifications
    }
  }
`;

export const PLAN_OWNER_VIEW = gql`
  query PlanOwner($id: ID!) {
    planOwner(id: $id) {
      id
      name
      ceo
      phone
      email
      webSite
      about
      logo
      photos
      recommendedBy
      specifications
      createdAt
      updatedAt
    }
  }
`;
